module.exports = __webpack_public_path__ + "media/8.a8803179.mp3";